import { PageViewData } from '../GTM'

export const storePageViewData = (
    data: {
        pageType?: string
        pageName?: string
        virtualPagePath?: string
    },
    addStoredData: (data: PageViewData) => void
) => {
    const { pageType, pageName, virtualPagePath } = data

    if (!pageName) {
        return false
    }

    addStoredData({
        pageDetails: {
            pageType,
            pageName,
            virtualPagePath
        }
    })
}
